import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Text = styled.p`
  margin: 0;
  text-align: center;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 14px;
  color: ${tokens.color.text.secondary};
`
